<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isRequiredLots="false"
              :onlyFarmsFruits="true"
              :isDrawerContent="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              @onChangeFilters="onChangeFilters"
              classFarms="col-12 col-sm-6 col-md-6"
              classLots="col-12 col-sm-6 col-md-6"
            >
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <template v-if="showGraph">
        <div class="row">
          <div
            class="col"
            v-if="chartOptions[0] && Object.keys(chartOptions[0]).length > 0"
          >
            <highcharts :options="chartOptions[0]"></highcharts>
          </div>
        </div>
        <br />
        <div class="row">
          <div
            :class="
              chartOptions[1] && chartOptions[2] ? 'col-md-6' : 'col-md-12'
            "
            v-if="chartOptions[1] && Object.keys(chartOptions[1]).length > 0"
          >
            <highcharts :options="chartOptions[1]"></highcharts>
          </div>
          <br />
          <div
            :class="
              chartOptions[1] && chartOptions[2] ? 'col-md-6' : 'col-md-12'
            "
            v-if="chartOptions[2] && Object.keys(chartOptions[2]).length > 0"
          >
            <highcharts :options="chartOptions[2]"></highcharts>
          </div>
        </div>
        <br />
        <div class="row">
          <div
            class="col"
            v-if="chartOptions[3] && Object.keys(chartOptions[3]).length > 0"
          >
            <highcharts :options="chartOptions[3]"></highcharts>
          </div>
        </div>
        <div class="row">
          <div
            :class="
              chartOptions[4] && chartOptions[5] ? 'col-md-6' : 'col-md-12'
            "
            v-if="chartOptions[4] && Object.keys(chartOptions[4]).length > 0"
          >
            <highcharts :options="chartOptions[4]"></highcharts>
          </div>
          <br />
          <div
            :class="
              chartOptions[4] && chartOptions[5] ? 'col-md-6' : 'col-md-12'
            "
            v-if="chartOptions[5] && Object.keys(chartOptions[5]).length > 0"
          >
            <highcharts :options="chartOptions[5]"></highcharts>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import Filter from 'src/components/Filter/Filters.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';

import { Chart } from 'highcharts-vue';
import MixinCharts from 'src/util/mixinCharts';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
    [Filter.name]: Filter,
    highcharts: Chart,
  },

  data() {
    return {
      reportType: 0,
      activeName: 'filter',
      valueCollapse: null,
      dataFilter: [],
      farms: null,
      openCollapse: false,
      chartOptions: [],
      data: [],
      showGraph: false,
    };
  },
  mixins: [mixinMasters, MixinMenu, MixinCharts, MixinPermissions],
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      if (this.reportType === null || ![0, 1].includes(Number(this.reportType)))
        return this.validationInputsRequired('type');
      else {
        this.seletedData = {};
        this.dataFilter = { ...data, reportType: this.reportType };
        this.getReportInfo();
      }
    },
    onChangeFilters() {
      this.showGraph = false;
    },
    getReportInfo() {
      this.showGraph = false;
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'grow/lossreport/getreportinfo';
      Axios.postMasters(data)
        .then((response) => {
          this.data = response.data.data;
          let graphs = this.data.graphs ? this.data.graphs : [];
          if (!Array.isArray(graphs)) {
            graphs = Object.values(graphs);
          }
          if (
            this.data &&
            this.data.graphs &&
            Object.keys(this.data.graphs).length > 0
          ) {
            this.chartOptions = [];
            graphs.forEach((item, index) => {
              if (item && Object.keys(item).length > 0) {
                this.$set(
                  this.chartOptions,
                  index,
                  JSON.parse(JSON.stringify(this.graph(item)))
                );
              }
            });
            this.showGraph = this.chartOptions.length > 0;
          } else {
            this.showGraph = false;
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
        })
        .catch((error) => {
          this.showMessageErrors(error);
        })
        .finally(() => {
          this.showHideLoading();
        });
    },
  },

  mounted() {
    this.selectedItemOnMenu('lossreport');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('lossreport');
  },
};
</script>
